import React, { Component } from "react";
import chunk from "lodash.chunk";
import Chart from "./Chart";
import { calculateRates } from "./calculation";
import "./Form.css";

const inputs = [
    {
        name: "dropRate",
        displayName: "Droprate",
        type: "number",
        placeholder: 100
    },
    {
        name: "rareRate",
        displayName: "Rare Rate",
        type: "number",
        placeholder: 100
    },
    {
        name: "epicRate",
        displayName: "Epic Rate",
        type: "number",
        placeholder: 100
    },
    {
        name: "spawnRate",
        displayName: "Spawnrate",
        type: "number",
        placeholder: 100
    },
    {
        name: "enemyNameColor",
        displayName: "Enemy Name Color",
        type: "text",
        placeholder: "Yellow/White/Red/Purple"
    },
    {
        name: "enemyLevel",
        displayName: "Enemy Level",
        type: "number",
        placeholder: 1
    },
    {
        name: "enemyMulti",
        displayName: "Enemy Droprate Multiplier",
        type: "number",
        placeholder: 1
    },
    {
        name: "enemySpawnChance",
        displayName: "Enemy Spawn Chance",
        type: "number",
        placeholder: 100
    },
    {
        name: "areaSpawnRate",
        displayName: "Area Spawnrate",
        type: "number",
        placeholder: 1
    },
    {
        name: "areaRareRate",
        displayName: "Area Rare Rate",
        type: "number",
        placeholder: 0
    },
    {
        name: "areaEpicRate",
        displayName: "Area Epic Rate",
        type: "number",
        placeholder: 0
    },
    {
        name: "areaEpicRateWM",
        displayName: "Area Epic Rate (Worst Moon)",
        type: "number",
        placeholder: 0
    },
    {
        name: "areaIADropRate",
        displayName: "Area IA Chance",
        type: "number",
        placeholder: 0
    },
    {
        name: "bestiaryLevel",
        displayName: "Bestiary Level",
        type: "number",
        placeholder: 0
    },
    {
        name: "secondsToKill",
        displayName: "Seconds to Kill",
        type: "number",
        placeholder: 0
    },
    {
        name: "hardcore",
        displayName: "Hardcore",
        type: "checkbox"
    },
    {
        name: "worstMoon",
        displayName: "Worst Moon",
        type: "checkbox"
    },
    {
        name: "apocalypse",
        displayName: "Apocalypse",
        type: "checkbox"
    },
    {
        name: "IAMastered",
        displayName: "IA Mastered",
        type: "checkbox"
    },
    {
        name: "gemOfGoodLuck",
        displayName: "GoGL Equipped",
        type: "checkbox"
    }
];

class Form extends Component {
    onChange = (e) => {
        let value;
        if (e.target.type === "text") value = e.target.value;
        else if (e.target.type === "number") value = e.target.valueAsNumber;
        else if (e.target.type === "checkbox") value = e.target.checked;

        this.setState({
            values: {
                ...this.state.values,
                [e.target.name]: value
            }
        });
    }

    constructor(props) {
        super(props);

        const initialValues = {};
        for (const i of inputs) {
            if (i.type === "text") initialValues[i.name] = "";
            else if (i.type === "number") initialValues[i.name] = i.placeholder;
            else if (i.type === "checkbox") initialValues[i.name] = false;
        }

        this.state = { values: initialValues };
    }
    
	render() {
        const rates = calculateRates(this.state.values);
		return (
            <form className="Form">
                <div className="columns">
                    {chunk(inputs, 7).map((arr, index) => (
                        <div key={index} className="column">
                            {arr.map(i => (
                                <div key={i.name}>
                                    <span>{i.displayName}: </span>
                                    <input
                                        placeholder={i.placeholder}
                                        name={i.name}
                                        type={i.type}
                                        checked={this.state.values[i.name]}
                                        value={this.state.values[i.name]}
                                        onChange={this.onChange}
                                    />
                                </div>
                            ))}
                        </div>
                    ))}

                    <div className="column canvas">
                        <Chart {...rates} />
                    </div>
                </div>
            </form>
		);
	}
}

export default Form;



// WEBPACK FOOTER //
// ./src/Form.js